export default __webpack_public_path__ + "static/media/21.b6b23079.png";